import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Дерево обнимало ветками фонарь.
      </p>
      
      <p class="mb-3">
        Он рос рядом, и был такой одинокий. Высокий и стройный, с одним прекрасным цветком, ярко сиявшим по ночам, -- но совсем без веток! Может, о нём некому было позаботиться, и он совсем опустил руки в отчаянии… И только цветок на вершине разрывал тьму в немом призыве: придите, вспомните обо мне!
      </p>
      
      <p class="mb-3">
        Дерево ласкало его листьями, засыпало семенами. Может, он откликнется; может, родятся у него новые цветки, много новых цветков! 
      </p>
      
      <p class="mb-3">
        Так и стояли они рядом: живое дерево и мёртвый железный фонарь. 
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Секретная жизнь в городе`
}

const itemDate = {
  rus: `26 июля 2023`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;